import {
  INVOICES_DOMAIN,
  INVOICES_PATHS,
} from 'modules/invoices/route-constants';
import { MESSAGES_PATHS } from 'modules/messages/route-constants';
import { RFI_REQUESTS_DOMAIN } from 'modules/rfi-requests/route-constants';
import {
  TASKS_LEGACY_DOMAIN,
  TASKS_PATHS,
} from 'modules/tasks/route-constants';
import { WORKFLOWS_PUBLIC_DOMAIN } from 'modules/workflow/route-constants';

export const getNotificationRedirectUrl = (
  type: string,
  elementId: number | string,
  path?: string
) => {
  const normalizedType = type.toLowerCase();

  if (normalizedType === 'bill') {
    return `/${INVOICES_DOMAIN}${INVOICES_PATHS.details}/${elementId}`;
  }

  // added for legacy support
  if (normalizedType === 'alert') {
    return `${MESSAGES_PATHS.alert}/${elementId}`;
  }

  if (normalizedType === 'message') {
    return `/${elementId}`;
  }

  if (normalizedType === 'task') {
    // TODO: Remove legacy path when tasks are migrated to new domain
    // return `/${TASKS_DOMAIN}${TASKS_PATHS.details}/${elementId}`;
    return `/${TASKS_LEGACY_DOMAIN}${TASKS_PATHS.legacy}/${elementId}`;
  }

  if (normalizedType === 'request') {
    return `/${WORKFLOWS_PUBLIC_DOMAIN}/${elementId}`;
  }

  // RFI (Tax Organizer) request: backend sends url e.g. "rfi-requests/uuid"
  if (normalizedType === 'rfirequest') {
    return path ? `/${path}` : `/${RFI_REQUESTS_DOMAIN}/${elementId}`;
  }

  return path ? `/${path}` : '/';
};

export default getNotificationRedirectUrl;
